<!--<div class="container">
  <div class="row g-4  row-cols-1 row-cols-lg-2">
    <div class="col py-5">
      <div class="col-6 mx-auto lh-sm">
        <span style="color: var(&#45;&#45;primary-color)" class="fs-2 fw-bold ">Tu bienestar,
          <br>
          <span class="fw-light fst-italic">nuestro compromiso</span>
        </span>
      </div>
    </div>
    <div class="col">
      <img ngSrc="./assets/img/terapiaFisica/imgInfo.svg" alt="" height="500" width="500">
    </div>
  </div>
  </div>-->


<div class="container col-xxl-8 px-4 ">
  <div class="row flex-lg-row-reverse align-items-center g-5 ">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="./assets/img/terapiaFisica/imgInfo.svg" class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="400" height="150" loading="lazy">
    </div>
    <div class="col-lg-6">
      <p class="fs-2 fw-bold my-0  " style="color: var(--primary-color)">Tu bienestar,</p>
      <p class="fs-2 lh-1" style="color: var(--primary-color)">nuestro compromiso</p>
      <!--      <span class="fst-italic fw-bolder" style="color: var(&#45;&#45;primary-color)">*Cobertura dentro de Guayaquil</span>-->
    </div>
  </div>
</div>
